import styled from "styled-components";

import {
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
  SCROLLBAR_STYLES,
} from "../../../../constants/Styles";

export const ResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Result = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
`;

export const ResultTitle = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size24};
  flex: 1;
  line-height: 1.5rem;
`;

export const ResultMessageContainer = styled.div`
  flex: 1;
  line-height: 1.5rem;
`;

export const StatusMessage = styled.div<{ color: string }>`
  font-weight: ${FONT_WEIGHT.weight700};
  color: ${({ color }) => color};
`;

export const Container = styled.div`
  position: relative;
  margin-bottom: 1rem;
`;

export const TableContainer = styled.div<{ runningAdditionalChecks: boolean }>`
  margin-top: 1rem;
  max-height: 450px;
  position: relative;
  overflow: auto;
  ${SCROLLBAR_STYLES};

  ${({ runningAdditionalChecks }) =>
    runningAdditionalChecks && `filter: brightness(50%);`}
`;

export const LocationListItem = styled.div<{ selected: boolean }>`
  cursor: pointer;
  background-color: ${({ selected }) =>
    selected ? COLORS.accent : COLORS.inputGray};
  color: ${({ selected }) =>
    selected ? COLORS.altSecondary : COLORS.secondaryLight};
`;

export const LocationsList = styled.div`
  max-height: 20rem;
  overflow-y: scroll;
  background: ${COLORS.tableBackground};
  ${SCROLLBAR_STYLES};
`;

export const DetailsSidebarContainer = styled.div`
  width: 20rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DetailsContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 1rem;
`;

export const LearnMore = styled.div<{ center?: boolean }>`
  ${({ center }) => center && "text-align: center;"}
  font-size: ${FONT_SIZE.size14};
  color: ${COLORS.secondaryLight};
`;
